export default __webpack_public_path__ + "mobile_top_bknmsg.9b547a.png";